import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { profile, axiosConfig } from 'api';
import { AxiosResponse } from 'axios';
import { RootState, MyThunkDispatch } from 'store';

import { fetchHasAccess } from 'actions/accessLog';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { Group } from 'models/group';
import { GroupedListModel } from 'models/groupedList';
import GroupSelectList from 'screens/components/GroupList';

const GroupListContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const [groupList, setGroupList] = useState<GroupedListModel[]>([]);
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);
  const adminId = useSelector((state: RootState) => (state.user.accountResult ? state.user.accountResult?.id : ''));

  const tourLoading = useSelector((state: RootState) => state.accessLog.isLoading);
  const hasAccess = useSelector((state: RootState) => state.accessLog.ListGroups);

  useEffect(() => {
    const screenName = 'ListGroups';
    dispatch(fetchHasAccess(screenName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const {
          data: { data },
        } = await profile.get<AxiosResponse<Group[]>>('/UserGroup/GetAll', axiosConfig);

        setGroupList(
          data.map((group: Group) => ({
            id: group.id,
            name: group.name,
            badges: group.users.map((badge: any) => ({ id: badge.id, name: badge.name, lastName: badge.lastName })),
          })),
        );
      } catch (error) {
        toast.add({
          type: 'danger',
          message: t('group.groupAggregation.errorFetch'),
        });
        setLoading(false);
      }
      setLoading(false);
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <GroupSelectList groupList={groupList} isLoading={isLoading} tourHasAccess={hasAccess} tourLoading={tourLoading} />
  );
};

export default GroupListContainer;
